import { usePathname } from 'expo-router';
import { useEffect } from 'react';

import { useAuth } from '@/src/features/auth/use-auth';
import { setAnalyticsUserId, trackScreenView } from '@/src/lib/analytics';

export function AnalyticsTracker() {
  const pathname = usePathname();
  const { user } = useAuth();

  useEffect(() => {
    trackScreenView(pathname);
  }, [pathname]);

  useEffect(() => {
    setAnalyticsUserId(user?.uid ?? null);
  }, [user?.uid]);

  return null;
}
